export const BASE_PATH = window.REGISTRATION_APPEND_URI
  ? window.REGISTRATION_APPEND_URI.replace(/\//, '')
  : '';
export const BASE_URL = `${document.location.protocol}//${document.location.host}${BASE_PATH ? `/${BASE_PATH}` : ''}`;
export const API_URL = `${BASE_URL}/api`;
export const IMAGE_BASE_URL = process.env.NODE_ENV === 'production'
  ? `${BASE_URL}/assets`
  : 'http://localhost:8081';
export const DEFAULT_TOURNAMENT_IMG = `${IMAGE_BASE_URL}/350x200_Pinstar_Thmnl.jpg`;
export const DEFAULT_TOURNAMENT_IMG_LARGE = `${IMAGE_BASE_URL}/usbc-banner.png`;
export const ENVIRONMENT = window.ENVIRONMENT || 'UNKNOWN';
export const GOOGLE_ANALYTICS_TRACKING_ID = window.GOOGLE_ANALYTICS_TRACKING_ID || 'UA-90923542-1';
export const ALLOW_CAPTAIN_CHANGE_SQUAD = window.ALLOW_CAPTAIN_CHANGE_SQUAD || false;
export const APP_VERSION = window.APP_VERSION || '1.0.0.0';
export const SSO_CLOCK_SKEW = window.SSO_CLOCK_SKEW || 300;
export const FACEBOOK_PIXEL_ID = window.FACEBOOK_PIXEL_ID || '1101352990766581';



// WEBPACK FOOTER //
// ./src/features/shared/variables.js